import { createContext, ReactNode } from "react";

/**
 * Something a wrapper wants shown inside a `TableSorted` header row — at the
 * right-hand end of the last header cell, in the header's own band, the way
 * antd puts icons in a column header. The admin `TableWrapper` uses it for
 * the global Refresh control. Null (the default, and what every table outside
 * a provider sees) renders the header exactly as before.
 */
export const TableHeaderExtrasContext = createContext<ReactNode | null>(null);
